import { FC, Dispatch, SetStateAction } from 'react';
import { WbDrawer } from '@agilelab/plugin-wb-platform';
import { EditServiceAccountForm } from './EditServiceAccountForm';
import { Entity } from '@backstage/catalog-model';

export type EditServiceAccountDrawerProps = {
  serviceAccount: Entity;
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
  onEdited?: () => void;
};

export const EditServiceAccountDrawer: FC<EditServiceAccountDrawerProps> = ({
  serviceAccount,
  open,
  setOpen,
  onEdited,
}) => {
  return (
    <WbDrawer
      open={open}
      builtinDrawerContent={false}
      setOpen={setOpen}
      PaperProps={{
        style: {
          width: '40%',
        },
      }}
      ModalProps={{ keepMounted: false }}
      title="Edit Service Account"
    >
      <EditServiceAccountForm
        serviceAccount={serviceAccount}
        onEdited={onEdited}
      />
    </WbDrawer>
  );
};
